
import { HttpClient } from '@angular/common/http';
import { DbTable } from '../db-table';
import { User } from '../../../../core/auth';
import { DbUsers, DbOrders } from './db-users';
import { DbInvitations } from "./DbInvitations";
import { DbProducts,  DbPaymentMethods, DbFinancialTransactions } from "./DbProducts";
import { Product, Order, Suggestion, AssociatedProduct } from '../../../../core/_shared/models/product';
import { Scheme } from "../../../../core/_shared/models/Scheme";
import { Invitation } from '../../../../core/_shared/models/Invitation';
import { DbSuggestions } from './DbSuggestions';
import { DbAssociatedProducts } from './db-associated-products';
import { DbAdminSchemes } from './db-admin-schemes';
import { DbSchemes } from './db-schemes';
import { DbApplicationUsers } from './DbApplicationUsers';
import { WebApiService } from '../../WebApiService';

export class RelationalDatabase {


    constructor(private _http: HttpClient, private _webApi:WebApiService) {

    }

    getUsers(): DbUsers {

        return new DbUsers(this._http,this._webApi)
    }


    getApplicationUsers() {
        return new DbApplicationUsers(this._http,this._webApi)
      }
   
      

  getFinancialTransactions():  DbFinancialTransactions {
    return new DbFinancialTransactions(this._http,this._webApi)
}


    getProducts(): DbTable<Product> {
        return new DbProducts(this._http,this._webApi)
    }

    getPaymentMethods():  DbPaymentMethods {
        return new DbPaymentMethods(this._http,this._webApi)
    }

      
    getSchemes(): DbSchemes {
        return new DbSchemes(this._http,this._webApi)
    }
    getAdminSchemes(): DbAdminSchemes {
        return new DbAdminSchemes(this._http,this._webApi)
    }


    getOrders(): DbOrders{
        return new DbOrders(this._http,this._webApi)
    }

    getSuggestions(): DbTable<Suggestion> {
        return new DbSuggestions(this._http,this._webApi)
    }

    getInvitations(): DbTable<Invitation> {
        return new DbInvitations(this._http,this._webApi)
    }


    getAssociatedProducts(productId: number): DbTable<AssociatedProduct> {

        let result = new DbAssociatedProducts(this._http,this._webApi, productId);

        return result;
    }



}